import './search-bar.scss';

interface Props {
    children: React.ReactNode
}

const SearchBar: React.FC<Props> = ({ children }) => {
    return (
        <div className='search-bar'>
            {children}
        </div>
    );
}

export default SearchBar;
